import { applyMiddleware, compose, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'
import reducers from './reducers'
import rootSaga from './sagas'
import socketMiddleware from './middlewares/socketMiddleware'
import postMessageMiddleware from './middlewares/postMessageMiddleware'
import errorHandlingMiddleware from './middlewares/errorHandlingMiddleware'
import generalMiddleware from './middlewares/generalMiddleware'

// const store = createStore(reducers)
const sagaMiddleware = createSagaMiddleware()

let composeEnhancers = compose
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const windowsObj = window as any
if (typeof windowsObj === 'object' && windowsObj.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
	composeEnhancers = windowsObj.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
		// Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
	})
}

const enhancer = composeEnhancers(
	applyMiddleware(sagaMiddleware, generalMiddleware, socketMiddleware, postMessageMiddleware, errorHandlingMiddleware)
)

const store = createStore(reducers, enhancer)

sagaMiddleware.run(rootSaga)

export default store
